export const ShiftTheme = {
    LHR: {
        base: 'bg-emerald-100 border-emerald-300 text-emerald-800',
        hover: 'hover:bg-emerald-200 hover:shadow-md',
        icon: '✈️',
        label: 'LHR Clearer'
    },
    CLEARER: {
        base: 'bg-sky-100 border-sky-300 text-sky-800',
        hover: 'hover:bg-sky-200 hover:shadow-md',
        icon: '🛫',
        label: 'LGW Clearer'
    },
    OFFICE: {
        base: 'bg-indigo-100 border-indigo-300 text-indigo-800',
        hover: 'hover:bg-indigo-200 hover:shadow-md',
        icon: '🏢',
        label: 'Office'
    },
    CONTROL: {
        base: 'bg-amber-100 border-2 border-amber-400 text-amber-900 font-bold',
        hover: 'hover:bg-amber-200 hover:shadow-md',
        icon: '🎮',
        label: 'Control'
    },
    WAREHOUSE: {
        base: 'bg-slate-100 border-slate-300 text-slate-800',
        hover: 'hover:bg-slate-200 hover:shadow-md',
        icon: '📦',
        label: 'Warehouse'
    },
    LEAVE_APPROVED: {
        base: 'bg-rose-100 border-rose-300 text-rose-800',
        hover: 'hover:bg-rose-200',
        icon: '🏖️',
        label: 'Leave'
    },
    LEAVE_PENDING: {
        base: 'bg-white border-2 border-rose-200 border-dashed text-rose-600',
        hover: 'hover:bg-rose-50',
        icon: '⏳',
        label: 'Pending Leave'
    },
    EMPTY: {
        base: 'bg-white hover:bg-gray-50',
        weekend: 'bg-slate-50/50 hover:bg-slate-100'
    }
};

export const getShiftStyle = (shift: any, date?: string | Date) => {
    if (!shift) {
        if (date) {
            const d = new Date(date);
            const isWeekend = d.getDay() === 0 || d.getDay() === 6;
            return {
                base: isWeekend ? ShiftTheme.EMPTY.weekend : ShiftTheme.EMPTY.base,
                hover: '',
                icon: ''
            };
        }
        return { base: ShiftTheme.EMPTY.base, hover: '', icon: '' };
    }

    // Handle Leave (if passed as a shift-like object or separate logic)
    // Assuming strict shift types for now

    const type = shift.type?.toUpperCase();

    if (type === 'LHR') return ShiftTheme.LHR;
    if (type === 'CLEARER') return ShiftTheme.CLEARER;
    if (type === 'CONTROL') return ShiftTheme.CONTROL;
    if (type === 'OFFICE') return ShiftTheme.OFFICE;
    if (type === 'WAREHOUSE') return ShiftTheme.WAREHOUSE;

    return ShiftTheme.CLEARER;
};

export const getShiftAbbreviation = (shift: any) => {
    if (!shift) return '';
    if (shift.type === 'CONTROL') return 'CTRL';
    if (shift.type === 'OFFICE') return 'OFFICE';
    if (shift.type === 'LHR') return 'LHR';
    if (shift.type === 'CLEARER') return 'LGW';
    if (shift.type === 'WAREHOUSE') return 'WH';
    return shift.type?.substring(0, 2).toUpperCase() || '';
};

export const getStaffShiftLabel = (shift: { type?: string; location?: string | null } | null | undefined) => {
    if (!shift?.type) return '';
    if (shift.type !== 'CLEARER') return shift.type;

    const location = String(shift.location || '').toUpperCase();
    if (location.includes('LHR') || location.includes('HEATHROW')) return 'LHR';
    return 'LGW';
};

export const getLeaveStyle = (status: string) => {
    return status === 'APPROVED' ? ShiftTheme.LEAVE_APPROVED : ShiftTheme.LEAVE_PENDING;
};
